<template>
  <div class="plans-page">
    <div class="container py-3">
      <div class="text-center mb-3">
        <h1 class="display-5 fw-bold mb-1">Build Your Perfect Value Bundle</h1>
        <p class="lead mb-0">
          Select services from each category to create a custom package.
          <span class="text-primary fw-bold">Choose 3+ services for a 10% discount!</span>
        </p>
      </div>
      
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <QuadstarPlanSelector />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import QuadstarPlanSelector from '@/components/plans/QuadstarPlanSelector.vue';

export default defineComponent({
  name: 'QuadstarPlansView',
  components: {
    QuadstarPlanSelector
  }
});
</script>

<style scoped>
.plans-page {
  background-color: var(--bg-color, #ffffff);
  min-height: 100vh;
  background-image: 
    radial-gradient(circle at 10% 20%, rgba(var(--primary-rgb, 13, 110, 253), 0.05) 0%, transparent 20%),
    radial-gradient(circle at 90% 80%, rgba(var(--primary-rgb, 13, 110, 253), 0.05) 0%, transparent 20%);
}

[data-theme="dark"] .plans-page {
  background-image: 
    radial-gradient(circle at 10% 20%, rgba(var(--primary-rgb, 13, 110, 253), 0.1) 0%, transparent 20%),
    radial-gradient(circle at 90% 80%, rgba(var(--primary-rgb, 13, 110, 253), 0.1) 0%, transparent 20%);
}

.lead {
  font-size: 1.1rem;
}

@media (max-width: 768px) {
  .display-5 {
    font-size: 2rem;
  }
  
  .lead {
    font-size: 1rem;
  }
}
</style>